<template>
	<div class="display-flex flex-row flex-align-center width-100 my-4 tabs-container">
		<InspirationCenterTab
			:key="tab"
			:tab="tab"
			@tab-clicked="onTabClick"
			:isSelected="isTabSelected(tab)"
			v-for="tab in useInspirationTags"
		/>
	</div>
</template>
<script>
import InspirationCenterTab from './InspirationCenterTab.vue';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { useInspirationTags } from '@/store/modules/inspirationCenter/getters.js';
import { getInspirationTags } from '@/store/modules/inspirationCenter/actions.js';
import { ALL_TAG_NAME } from '@/components/InspirationCenter/inspiration-center.const.js';

export default {
	name: 'InspirationCenterTabs',
	props: { selectedTabs: { type: Array } },
	components: { InspirationCenterTab },
	computed: {
		...mapGettersShorthand({ useInspirationTags }),
		isAllMode() {
			return this.localSelectedTabs.includes(ALL_TAG_NAME);
		},
		localSelectedTabs: {
			get() {
				return this.selectedTabs;
			},
			set(value) {
				this.$emit('update:selectedTabs', value);
			},
		},
	},
	methods: {
		...mapActionsShorthand({ getInspirationTags }),
		isTabSelected(tab) {
			return this.localSelectedTabs.includes(tab);
		},
		onTabClick(tab) {
			if (this.isTabAllTab(tab)) {
				if (this.isTabSelected(tab)) {
					// double click on all tab
					return;
				} else {
					// make all tab active after something else was
					this.localSelectedTabs = [ALL_TAG_NAME];
					return;
				}
			}
			if (this.isTabSelected(tab)) {
				if (this.localSelectedTabs.length <= 1) {
					// tab clicked, but it was the only one selected, select everything
					this.localSelectedTabs = [ALL_TAG_NAME];
					return;
				}
				// remove tab from selected tabs
				this.localSelectedTabs = this.localSelectedTabs.filter((selectedTab) => selectedTab !== tab);
			} else {
				if (this.isAllMode) {
					this.localSelectedTabs = [tab];
				} else {
					this.localSelectedTabs.push(tab);
				}
			}
		},
		isTabAllTab(tab) {
			return tab === ALL_TAG_NAME;
		},
	},
	mounted() {
		this.getInspirationTags();
	},
};
</script>
<style lang="scss" scoped>
.tabs-container {
	overflow-x: auto;
}
</style>
